<template>
  <v-layout wrap style="">
    <v-flex xs8 style="padding: 10px;">
      <div style="background-color: white;">
    <v-data-table
      :headers="headers.filter(x => x.value !== 'WorkspaceName' || devices.filter(x => !x.WorkspaceID).length > 0)"
      :items="paymentsLinks"
      :items-per-page="-1"
      class="elevation-0"
      hide-default-footer
    >      
      <template 
        v-slot:top 
      >
        <v-layout wrap>
          <v-flex
            xs="6"
            style="padding-left:10px;"
          >
            <h1><v-icon large color="black">mdi-wallet</v-icon> Links de pago</h1>
          </v-flex>
          <v-flex
            xs="6"
            style="padding:10px;"
          >
            <v-layout wrap>
              <v-flex xs6 style="padding-left:10px;">
                <search :onSearch="handleSearch" :showClear="searchValue && searchValue.length > 0 ? true : false" :maxWidth="400" />
              </v-flex>
              <v-flex xs6 style="text-align: right;">
                <v-btn 
                  @click="handleGetData(null)"
                  block
                >
                  {{ $t('common.refresh', locale) }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:item.ident="{ item }">
        <a @click="editedID = item.ID">{{item.Name ? item.Name : item.ID }}</a>
      </template>
      <template v-slot:item.Status="{ item }">
        <v-btn
          x-small
          elevation="0"
          dark
          :color="status[item.Status] ? status[item.Status].color : 'black'"
        >
          {{status[item.Status] ? status[item.Status].text : item.Status}}
        </v-btn>
      </template>
      <template v-slot:item.dates="{item}">
        <span style="color:#cccccc;">Creado</span> 
        <br/>
          {{getDate(item.CD)}}
        <br/>
        <span style="color:#cccccc;">Actualizado</span> 
        <br/>
        {{getDate(item.CD)}}
      </template>
    </v-data-table>
    <pagination
      v-if="count!= null"
      :startIndex="startIndex"
      :count="count"
      :itemsPerPage="itemsPerPage"
      :onGetData="handleGetData"
      :locale="locale"
      :onChangeItemsPerPage="handleChangeItemsPerPage"
      :arrayPages="[5, 10, 15, 20, 25, 30, 50]"
    />
      </div>
    <!--player-form /-->
    </v-flex>
    <v-flex xs4 style="padding: 10px;">
      <v-btn 
        v-if="!editedID"
        @click="handleAddItem"
        block
        color="primary"
      >
        añadir
      </v-btn>
      <div
        style="padding: 10px;background-color:white;min-height: calc(100vh);"
      >
        <payments-form
          v-if="editedID"
          :editedID="editedID"
          :onClose="handleClose"
        />
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
import Search from '@/components/Search'
import Pagination from '@/components/customTable/Pagination'
import PaymentsForm from './PaymentsForm'
export default {
  components: {
    Search,
    Pagination,
    PaymentsForm,
  },
  data: () => ({
    count: null,
    startIndex: 0,
    itemsPerPage: 25,
    presentations: [],
    paymentsLinks: [],
    editedID: null,
    searchValue: '',
  }),
  computed: {
    ...mapState('app',['locale', 'playersWorkspace']),
    status () {
      return {
        created: {
          color: 'blue',
          text: 'Creado',
        },
        paid: {
          color: 'green',
          text: 'Pagada',
        },
        rejected: {
          color: 'red',
          text: 'Rechazada',
        },
        observation: {
          color: 'orange',
          text: 'Revisión manual',
        },
      }
    },
    workspaceID () {
      return this.playersWorkspace
    },  
    environment () {
      return 'players'
    },
    headers () {
      return [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'ident',
        },
        { text: 'Importe', sortable: false, value: 'Amount' },
        { text: 'Concepto', sortable: false, value: 'Concept' },
        { text: 'Estado', sortable: false, value: 'Status' },
        { text: 'URL', sortable: false, value: 'url' },
        { text: 'Fechas', sortable: false, value: 'dates' },
        /*
        { text: 'Cliente', sortable: false, value: 'WorkspaceName' },
        { text: 'Presentation', align: 'center', sortable: false, value: 'Presentation' },
        { text: 'Time(seg)', sortable: false, value: 'Time' },
        { text: 'APK', align: 'center', sortable: false, value: 'APK' },
        { text: 'LCD', sortable: false, value: 'LCD' },
        { text: 'LCD', sortable: false, value: 'Seconds' },
        */
      ]
    },
  },
  mounted () {
    const aux = localStorage.getItem('paymentsItemsPerPage')
    if (aux && aux !== this.itemsPerPage) this.itemsPerPage = aux && aux.length > 0 ? aux | 0 : 25
    this.handleGetData()
  },
  methods: {
    getDate (v) {
      if (!v) return ''
      return v.split('T').join(' ').split('.').shift()
      /*
      v = new Date(v)
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }

      return v.toLocaleDateString('es', options)
      */
    },
    handleChangeItemsPerPage (v) {
      this.startIndex = 0
      this.itemsPerPage = v
      localStorage.setItem('paymentsItemsPerPage', v)
      this.handleGetData()
    },
    handleSearch (v) {
      this.searchValue = v
      this.handleGetData()
    },
    async handleGetData (v) {
      this.loading = true
      this.handleClose()
      this.count = 0
      this.paymentsLinks = []
      if (v !== null && v != undefined) this.startIndex = v
      api.getAll('payments', `v1/private/payments/`, this.startIndex, this.itemsPerPage, this.searchValue)
        .then(response => {
          this.count = response.count
          this.paymentsLinks = response.data.map(item => {
            if (item.Amount) {
              let aux = item.Amount.toString().padStart(3, "0")
              let b = aux.substring(aux.length -2, aux.length)
              let a = aux.substring(0, aux.length -2)

              item.Amount = `${a}.${b} €`
            }
            item.url = `https://www.dtouch.es/#/ap/${item.ID}`
            return item
          })
          this.loading = false
        })
    },
    handleAddItem () {
      this.editedID = 'new'
    },
    handleClose (refresh) {
      this.editedID = null
      if (refresh) this.handleGetData()
    },
  },
}
</script>

